<div class=" ml-1 mr-1">

  <div class="columns mb-5">
    <div class="column">
      <p class="has-text-centered is-bold is-size-5">Für</p>
      <svg class="circle__progressbar max-w-20 blue"
           viewBox="0 0 36 36">
        <path class="circle__progressbar__circle__bg" d="M18 2.0845
                                a 15.9155 15.9155 0 0 1 0 31.831
                                a 15.9155 15.9155 0 0 1 0 -31.831"></path>
        <path [attr.stroke-dasharray]="calculateRotationOrderProgress() + ', 100'"
              class="circle__progressbar__circle" d="M18 2.0845
                                a 15.9155 15.9155 0 0 1 0 31.831
                                a 15.9155 15.9155 0 0 1 0 -31.831"></path>
        <text class="circle__progressbar__percentage" x="18"
              y="20.35">{{ calculateRotationOrderProgress() |number: '1.0-2':'de' }}
          %
        </text>
      </svg>
      <p class="has-text-centered is-bold is-size-5">der Portfolioassets ist die Turnusbestellung
        aktiviert</p>
    </div>
  </div>

  <div class="columns">
    <div class="column has-background-darkblue has-round-border has-text-white">
      <div class="columns">
        <div class="column is-1 has-text-centered w-5">
          <input type="checkbox" [disabled]="platformProfile.properties.length < 1"
                 [checked]="areAllSavedPropertiesSelected()" (click)="selectAllSavedProperties()"
                 class="custom-checkbox">
        </div>
        <div class="column is-1 has-text-centered">ID</div>
        <div class="column is-2 has-text-centered">Objektname</div>
        <div class="column is-2 has-text-centered">Straße</div>
        <div class="column is-1 has-text-centered">PLZ</div>
        <div class="column is-1 has-text-centered">Ort</div>
        <div class="column is-2 has-text-centered">Festgelegter Turnus</div>
        <div class="column is-2 has-text-centered pl-0 w-20">
          <a (click)="openRotationOrderModal(undefined)" *ngIf="selectedSavedProperties.length > 0"
             class="custom-a-button inverted smaller-a-button does-not-wrap">
            Mehrere ändern
          </a>
        </div>
      </div>
    </div>
  </div>

  <ng-container *ngIf="platformProfile.properties">
    <ng-container *ngFor="let savedProperty of platformProfile.properties">
      <div class="columns mt-3"
           *ngIf="selectedMandateId === savedProperty.mandateId || selectedMandateId === 'init'">
        <div class="column card has-round-border line-height-is-3">
          <div class="columns">
            <div class="column is-1 has-text-centered w-5">
              <input type="checkbox" [checked]="isSavedPropertySelected(savedProperty)"
                     (click)="selectSavedProperty(savedProperty)"
                     class="custom-checkbox">
            </div>
            <div appTooltip matTooltip="{{savedProperty.ownId}}"
                 class="column is-1 has-text-centered truncate">{{ savedProperty.ownId }}
            </div>
            <div appTooltip matTooltip="{{savedProperty.name}}"
                 class="column is-2 has-text-centered truncate">{{ savedProperty.name }}
            </div>
            <div appTooltip matTooltip="{{savedProperty.street}}"
                 class="column is-2 truncate has-text-centered">{{ savedProperty.street }}
            </div>
            <div class="column is-1 has-text-centered">{{ savedProperty.zip }}</div>
            <div appTooltip matTooltip="{{savedProperty.town}}"
                 class="column is-1 truncate has-text-centered">{{ savedProperty.town }}
            </div>
            <div class="rotation-order-info-container">
              <ng-container
                  *ngIf="getRotationOrdersForSpecificProductFromSavedProperty('grunde', savedProperty).length > 0; else gbaFallback">
                <p class="is-size-7 has-border has-round-border has-text-centered mt-1 is-bold line-height-is-1-5 active-rotation"
                   matTooltip="{{getProductLongName('grunde', products, null)}}">
                  GBA
                  | {{ getDateStringForRotationOrderForSpecificProduct(['grunde'], savedProperty) }}
                </p>
              </ng-container>
              <ng-template #gbaFallback>
                <p matTooltip="{{getProductLongName('grunde', products, null)}}"
                   class="is-size-7 has-border has-round-border has-text-centered mt-1 is-bold line-height-is-1-5 disabled">
                  GBA | --
                </p>
              </ng-template>

              <ng-container
                  *ngIf="getRotationOrdersForSpecificProductFromSavedProperty('liegen', savedProperty).length > 0 || getRotationOrdersForSpecificProductFromSavedProperty('eliegen', savedProperty).length > 0; else lkFallback">
                <p class="is-size-7 has-border has-round-border has-text-centered mt-1 is-bold line-height-is-1-5 active-rotation"
                   matTooltip="(nicht amtliche) {{getProductLongName('liegen', products, null)}}">
                  LK
                  | {{ getDateStringForRotationOrderForSpecificProduct(['liegen', 'eliegen'], savedProperty) }}
                </p>
              </ng-container>
              <ng-template #lkFallback>
                <p matTooltip="(nicht amtliche) {{getProductLongName('liegen', products, null)}}"
                   class="is-size-7 has-border has-round-border has-text-centered mt-1 is-bold line-height-is-1-5 disabled">
                  LK | --
                </p>
              </ng-template>

              <p *ngIf="getNumberOfProductsFromRotationOrderForSavedProperty(savedProperty) >= 3"
                 (click)="openRotationOrderModal(savedProperty)"
                 matTooltip="Turnus bearbeiten"
                 class="is-size-7 is-bold has-text-centered is-clickable line-height-is-1-5">. . .</p>
            </div>

            <div class="column is-2 has-text-centered pl-0 w-20">
              <a (click)="selectedSavedProperties.length > 0 ? $event.stopPropagation() : openRotationOrderModal(savedProperty)"
                 [ngClass]="{'disabled': selectedSavedProperties.length > 0}"
                 class="custom-a-button smaller-a-button does-not-wrap">
                {{ getNumberOfRotationOrdersForSavedProperty(savedProperty) > 0 ? "Bearbeiten" : "Turnus setzen" }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-container>

  <div class="columns mt-3" *ngIf="!platformProfile.properties || platformProfile.properties.length === 0">
    <div class="column has-text-centered">
      Es konnten keine Bestandsobjekte gefunden werden.
    </div>
  </div>
</div>

<!-- Popup Turnusbestellungen erstellen / bearbeiten -->
<app-modal [closeable]="false" [active]="showRotationOrderModal" [width]="1150">
  <!-- Überschrift -->
  <div *ngIf="!multipleSelectionModal" class="title is-4 has-text-centered is-bold color-darkblue">Turnusbestellung
    anlegen
  </div>
  <div *ngIf="multipleSelectionModal" class="title is-4 has-text-centered is-bold color-darkblue">Turnusbestellung
    für {{ selectedSavedProperties.length }} Objekte anlegen
  </div>

  <div class="columns">
    <div class="column is-12 mb-0 has-text-centered">
      <div class="info-border mb-3">
        <div class="columns">
          <div class="column has-text-centered">
            <p class="is-size-4 has-text-centered is-bold color-darkblue">
              Hinweis:
            </p>
          </div>
        </div>
        <div class="columns">
          <div class="column has-text-centered">
            <p class="is-bold color-darkblue">Gewünschtes Bereitstellungsdatum</p>
            <p class="p-2">Bitte beachten Sie, dass zur rechtzeitigen Bereitstellung der Dokumente diese einige Tage vor
              dem gewünschten Datum beantragt werden, so dass das tatsächliche Bereitstellungsdatum um einige Tage
              abweichen kann.</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="showDifferentRotationOrderUserError" class="columns">
    <div class="column">
      <p class="error-text has-text-centered">Es gibt bereits eine Turnusbestellung für dieses Datum für einen anderen
        Nutzer.
        Ändern Sie entweder den Nutzer der schon existierenden Turnusbestellung oder den Nutzer für den Turnus den Sie
        hinzufügen möchten.</p>
    </div>
  </div>

  <div *ngIf="showMultiSelectionRotationOrderUserInformation" class="columns">
    <div class="column">
      <p class="info-text has-text-centered">
        Es liegt bereits mindestens eine Turnusbestellung für ein Bestandsobjekt mit gleichem Datum, jedeoch einem
        anderen zugeordneten Nutzer vor.
        Bitte beachten Sie, dass der Turnus nur erstellt wird, wenn für das jeweilige Bestandsobjekt
        entweder noch kein Turnus vorhanden ist oder wenn der bereits festgelegte Turnus demselben Nutzer zugeordnet
        ist.
      </p>
    </div>
  </div>

  <div class="columns">
    <div class="column margin-top-auto margin-bottom-auto">
      <div class="columns is-justify-content-center is-align-items-center">
        <div class="column">
          <p>Für welchen Nutzer soll die Bestellung immer aufgegeben werden?</p>
        </div>
        <div class="column is-flex is-justify-content-center">
          <div class="select-wrapper">
            <select class="dropdown has-round-border color-darkblue no-outline no-border has-box-shadow"
                    [(ngModel)]="userPicker">
              <option value="" disabled selected>Nutzer auswählen</option>
              <option *ngFor="let user of usersForPlatform" value="{{user.id}}">
                {{ user.firstname + ' ' + user.lastname }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="columns" id="rotation-order-date">

        <div class="column is-4 margin-auto">
          <div class="select-wrapper w-auto">
            <select class="dropdown has-round-border color-darkblue no-outline no-border has-box-shadow"
                    [(ngModel)]="documentPicker">
              <option value="" disabled selected>Dokument auswählen</option>
              <ng-container *ngFor="let product of products">
                <option *ngIf="product.rotationable" value="{{product.nameShort}}">
                  {{ product.name_long }}
                </option>
              </ng-container>
            </select>
          </div>
        </div>
        <!-- Tag -->
        <div class="column is-3 margin-auto">
          <div class="select-wrapper w-auto">
            <select class="dropdown has-round-border color-darkblue no-outline no-border has-box-shadow"
                    [(ngModel)]="dayPicker">
              <option value="" disabled selected>Tag</option>
              <option *ngFor="let day of days" value="{{day}}">
                {{ day }}
              </option>
            </select>
          </div>
        </div>
        <!-- Monat -->
        <div class="column is-3 margin-auto">
          <div class="select-wrapper w-auto">
            <select class="dropdown has-round-border color-darkblue no-outline no-border has-box-shadow"
                    [(ngModel)]="monthPicker" (change)="updateNumberOfDays(monthPicker?.valueOf())">
              <option value="" disabled selected>Monat</option>
              <option *ngFor="let month of months" value="{{month}}">
                {{ month }}
              </option>
            </select>
          </div>
        </div>

        <div *ngIf="products" class="column is-2 has-text-centered">
          <a (click)="!isRotationOrderInputValid() || isRotationAlreadyOrdered() ?  $event.stopPropagation() : addRotationOrder()"
             [ngClass]="{'disabled': !isRotationOrderInputValid() || isRotationAlreadyOrdered()}"
             [matTooltip]="!isRotationOrderInputValid() ? 'Bitte geben Sie vollständige Daten an' : (isRotationAlreadyOrdered() ? 'Es gibt bereits eine Turnusbestellung für das Dokument an dem Datum' : '')"
             class="custom-a-button line-height-is-3 does-not-wrap">
            + Hinzufügen
          </a>
        </div>
      </div>
    </div>
  </div>

  <div
      *ngIf="rotationOrders.length > 0 && (getNumberOfRotationOrdersForSavedProperty(selectedSavedPropertyForModal) > 0 || multipleSelectionModal)">
    <hr>

    <div class="title is-6 has-text-left is-bold color-darkblue">Ausgewählte Turnusse:</div>

    <div class="columns is-flex-wrap-wrap">
      <ng-container
          *ngFor="let rotationOrder of (multipleSelectionModal ? (rotationOrders | uniqueRotationOrders) : rotationOrders); let rotationOrderIndex = index">
        <ng-container
            *ngIf="selectedSavedPropertyForModal && rotationOrder.savedProperty.id === selectedSavedPropertyForModal.id || !rotationOrder.id">

          <div class="column is-12 grey-border has-round-border mb-4 mt-4"
               [ngClass]="{'error-border' : rotationOrderIndex === errorRotationOrderIndex}">
            <p class="mb-4 has-text-centered">Turnusbestellung für den Nutzer: <span
                class="is-bold">{{ getFullUserNameById(rotationOrder.userId) }}</span> <span class="edit-text"
                                                                                             (click)="openEditUserForRotationOrderModal(rotationOrder)">(Bearbeiten)</span>
            </p>
            <div class="columns is-flex-wrap-wrap">
              <ng-container *ngFor="let product of rotationOrder.products; let productIndex = index">
                <div
                    class="column is-one-third has-round-border card is-clickable mt-1 mb-3 p-0 custom-rotation-order-card">
                  <div class="columns">
                    <div class="column is-four-fifths ml-2 truncate" appTooltip
                         matTooltip="{{rotationOrder.day + '. ' + months[rotationOrder.month-1] + ' | ' + product.name_long}}">
                                <span class="is-bold">
                                    {{ rotationOrder.day + '. ' + months[rotationOrder.month - 1] }}
                                </span>
                      <span>
                                    {{ ' | ' + product.name_long }}
                                </span>
                    </div>
                    <div class="column is-one-fifth ml-4">
                      <div>
                        <svg (click)="openConfirmationDialog(rotationOrderIndex, productIndex)"
                             xmlns="http://www.w3.org/2000/svg" width="14.103" height="14.178"
                             viewBox="0 0 14.103 14.178">
                          <path id="Icon_metro-cross" data-name="Icon metro-cross"
                                d="M16.545,13.318h0l-4.278-4.3,4.278-4.3h0a.44.44,0,0,0,.1-.158.445.445,0,0,0-.1-.468L14.524,2.057a.44.44,0,0,0-.623,0h0l-4.278,4.3-4.278-4.3h0a.44.44,0,0,0-.623,0L2.7,4.089a.446.446,0,0,0,0,.626h0l4.278,4.3L2.7,13.318h0a.446.446,0,0,0,0,.626l2.021,2.032a.44.44,0,0,0,.623,0h0l4.278-4.3,4.278,4.3h0a.44.44,0,0,0,.623,0l2.021-2.032a.446.446,0,0,0,0-.626Z"
                                transform="translate(-2.571 -1.928)" fill="#707070"/>
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>

          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>

  <hr>

  <div class="columns">
    <div class="column">
    </div>
  </div>

  <div class="columns">
    <div class="column is-one-third">
      <a (click)="closeRotationOrderModal()" class="button back-button is-size-6 has-round-border">
        <div class="columns is-align-items-center is-justify-content-center">
          <div class="column">
            <p class="is-bold">Abbrechen</p>
          </div>
        </div>
      </a>
    </div>
    <div class="column is-one-third"></div>
    <div class="column is-one-third">
      <a (click)="updateRotationOrders()" type="submit" class="button buy-button is-size-6 has-round-border">
        <div class="columns is-justify-content-center is-align-items-center">
          <div class="column is-bold"><p>Speichern</p></div>
        </div>
      </a>
    </div>
  </div>
</app-modal>

<app-modal [closeable]="false" [active]="showEditUserForRotationOrderModal">

  <div class="title is-4 has-text-centered is-bold color-darkblue">Nutzer für Turnusbestellung anpassen</div>

  <div *ngIf="showUpdateUserError" class="columns">
    <div class="column">
      <p class="error-text has-text-centered">Bitte wählen Sie einen Nutzer aus.</p>
    </div>
  </div>

  <div class="columns is-justify-content-center is-align-items-center">
    <div class="column">
      <p class="has-text-centered">Für welchen Nutzer soll die Bestellung immer aufgegeben werden?</p>
    </div>
    <div class="column is-flex is-justify-content-center">
      <div class="select-wrapper">
        <select class="dropdown has-round-border color-darkblue no-outline no-border has-box-shadow"
                [(ngModel)]="userPicker">
          <option value="" disabled selected>Nutzer auswählen</option>
          <ng-container *ngFor="let user of usersForPlatform">
            <option *ngIf="editRotationOrder && user.id !== editRotationOrder.userId" value="{{user.id}}">
              {{ user.firstname + ' ' + user.lastname }}
            </option>
          </ng-container>
        </select>
      </div>
    </div>
  </div>

  <div class="columns" *ngIf="editRotationOrder">
    <div class="column">
      <p class="color-dark-gray is-size-6 has-text-centered">Bisher wurde die Bestellung immer für <span
          class="is-bold">{{ getFullUserNameById(editRotationOrder.userId) }}</span> aufgegeben</p>
    </div>
  </div>

  <div class="columns">
    <div class="column is-one-third">
      <a (click)="closeEditUserForRotationOrderModal()"
         [ngClass]="{'disabled' : updatingRotationOrderUser}" class="button back-button is-size-6 has-round-border">
        <div class="columns is-align-items-center is-justify-content-center">
          <div class="column">
            <p class="is-bold">Abbrechen</p>
          </div>
        </div>
      </a>
    </div>
    <div class="column is-one-third"></div>
    <div class="column is-one-third">
      <a (click)="handleRotationOrderUserUpdate()" type="submit"
         [ngClass]="{'disabled is-loading' : updatingRotationOrderUser}"
         class="button buy-button is-size-6 has-round-border">
        <div class="columns is-justify-content-center is-align-items-center">
          <div class="column is-bold"><p>Speichern</p></div>
        </div>
      </a>
    </div>
  </div>

</app-modal>
